import {AddressUpdateAction, AddressUpdateInitialState, ShippingAddressActions} from './types'
import {reducer} from '../../../reducers/helpers'

export const initialState: AddressUpdateInitialState = {
  shippingAddress: {
    address1: '',
    address2: '',
    city: '',
    firstName: '',
    isPending: false,
    lastName: '',
    phone: '',
    state: '',
    toBusinessAddress: false,
    version: null,
    zip: '',
  },
}

export default reducer(
  initialState,
  (state: AddressUpdateInitialState, action: ShippingAddressActions) => {
    switch (action.type) {
      case AddressUpdateAction.GET_SHIPPING_ADDRESS:
      case AddressUpdateAction.GET_SHIPPING_ADDRESS_PENDING:
        return {
          shippingAddress: {
            ...state.shippingAddress,
            isPending: true,
          },
        }
      case AddressUpdateAction.GET_SHIPPING_ADDRESS_SUCCESS:
        return {
          shippingAddress: {
            ...state.shippingAddress,
            ...action.payload,
            isPending: false,
          },
        }
      case AddressUpdateAction.GET_SHIPPING_ADDRESS_FAILURE:
        return {
          shippingAddress: {
            ...state.shippingAddress,
            isPending: false,
          },
          errors: action.payload ? [action.payload] : [],
        }
      case AddressUpdateAction.SAVE_SHIPPING_ADDRESS_PENDING:
        return {
          shippingAddress: {
            ...state.shippingAddress,
            isPending: true,
          },
        }
      case AddressUpdateAction.SAVE_SHIPPING_ADDRESS_FAILURE:
        return {
          shippingAddress: {
            ...state.shippingAddress,
            isPending: false,
          },
          errors: action.payload ? [action.payload] : [],
        }
      case AddressUpdateAction.SAVE_SHIPPING_ADDRESS_SUCCESS:
        return {
          shippingAddress: {
            ...state.shippingAddress,
            ...action.payload,
            isPending: false,
          },
        }
      default:
        return null
    }
  },
)
